export const REQUEST_INVITATION = 'ORGANIZATION_INVITATION/REQUEST_INVITATION';
export const RECEIVE_INVITATION = 'ORGANIZATION_INVITATION/RECEIVE_INVITATION';
export const ACCEPT_INVITE = 'ORGANIZATION_INVITATION/ACCEPT_INVITE';
export const REJECT_INVITE = 'ORGANIZATION_INVITATION/REJECT_INVITE';
